export default "__VITE_ASSET__B1AmU9Wv__"